/**
 * 音效设置工具
 * 用于管理通知音效的配置
 * 
 * 使用说明：
 * 1. 将音效文件放到 public/sounds/ 目录下（如：public/sounds/my-sound.mp3）
 * 2. 在浏览器控制台中配置：
 *    localStorage.setItem('notificationAudioSettings', JSON.stringify({
 *      enabled: true,
 *      useCustomAudio: true,
 *      customAudioUrl: '/sounds/my-sound.mp3',
 *      volume: 1.0
 *    }));
 * 3. 也可以使用在线音效文件的完整 URL
 * 4. 支持的格式：mp3, wav, ogg, aac
 */

const AUDIO_SETTINGS_KEY = 'notificationAudioSettings';

// 默认音效设置
const defaultSettings = {
  enabled: true, // 是否启用音效
  useCustomAudio: false, // 是否使用自定义音效
  customAudioUrl: '', // 自定义音效文件路径（相对路径或完整 URL）
  volume: 1.0, // 音量 (0 到 1)
  // 默认音效（可以使用系统内置的提示音或提供默认音效文件）
  defaultAudioUrl: '/sounds/notification.mp3' // 默认音效路径，需要放在 public/sounds 目录下
};

/**
 * 获取音效设置
 */
export const getAudioSettings = () => {
  try {
    const settings = localStorage.getItem(AUDIO_SETTINGS_KEY);
    if (settings) {
      const parsed = JSON.parse(settings);
      return { ...defaultSettings, ...parsed };
    }
  } catch (error) {
    console.error('读取音效设置失败:', error);
  }
  return defaultSettings;
};

/**
 * 保存音效设置
 */
export const saveAudioSettings = (settings) => {
  try {
    const currentSettings = getAudioSettings();
    const newSettings = { ...currentSettings, ...settings };
    localStorage.setItem(AUDIO_SETTINGS_KEY, JSON.stringify(newSettings));
    return true;
  } catch (error) {
    console.error('保存音效设置失败:', error);
    return false;
  }
};

/**
 * 重置音效设置为默认值
 */
export const resetAudioSettings = () => {
  try {
    localStorage.setItem(AUDIO_SETTINGS_KEY, JSON.stringify(defaultSettings));
    return true;
  } catch (error) {
    console.error('重置音效设置失败:', error);
    return false;
  }
};

/**
 * 获取当前使用的音效 URL
 */
export const getAudioUrl = () => {
  const settings = getAudioSettings();
  if (settings.useCustomAudio && settings.customAudioUrl) {
    return settings.customAudioUrl;
  }
  return settings.defaultAudioUrl;
};

